import { useState, useEffect } from "react";

// API
import { getTeam } from "../api/about";

// Bootstrap components
import Container from "react-bootstrap/Container";

// Custom styles
import "../scss/pages/aboutUs.styles.scss";

function AboutUs() {
  const [loading, setLoading] = useState(false);
  const [teamData, setTeamData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const { response, result } = await getTeam();
        if (response.status === 304) {
          setTeamData(result.docs);
        } else if (!response.ok) {
          console.error("Error fetching home :", response.ok);
        } else {
          setTeamData(result.docs);
        }
      } catch (error) {
        console.error("Error fetching  data", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  if (loading && teamData.length === 0) {
    return (
      <Container style={{ marginTop: "90px" }}>
        <h6 className="text-center py-3">Cargando información...</h6>
      </Container>
    );
  }
  return (
    <div className="about_us__wrapper">
      <section className="about_us__hero">
      </section>


      <section className="about_us__seo">
  <div className="container">
    
     <div className="row mb-5">
      <div className="col-12 col-lg-8">
        <div className="about-header-box">
          <h1 className="about-pre-title">Nuestra historia</h1>
          <h2 className="about-title">
            <strong>Desde 2009,</strong> trabajamos con <br className="d-none d-lg-block" /> pasión y compromiso
          </h2>
        </div>
      </div>
    </div>

    <div className="row about-content-row">

      <div className="col-12 col-lg-6 about-text-column">
        <p>
          <strong>En AFIX creemos en el poder de las ideas,</strong> cada proyecto que apoyamos es una 
          oportunidad para crecer juntos, superar desafíos y transformar sueños en realidades sólidas.
        </p>
        <p>
          Impulsados por <strong>la pasión, la experiencia y el compromiso,</strong> hemos construido una 
          comunidad fuerte que convierte cada desafío en oportunidad y seguimos inspirados por cada <strong>historia de éxito que ayudamos a escribir.</strong>
        </p>
        <p>
          Para nosotros, cada crédito otorgado no es solo un financiamiento, sino <strong>un impulso hacia 
          un futuro lleno</strong> de posibilidades.
        </p>
      </div>
      <div className="col-12 col-lg-6 about-values-column">
        <div className="value-block mb-4">
          <h3 className="value-subtitle">Nuestra misión</h3>
          <p>
            Creamos valor y desarrollo para pequeñas y medianas empresas, mediante el otorgamiento 
            de financiamiento oportuno y a la medida.
          </p>
        </div>

       <div className="value-block">
          <h3 className="value-subtitle">Nuestra visión</h3>
          <p>
            Ser una institución financiera pública, con cobertura nacional, reconocida en el mercado 
            por la claridad y eficiencia de sus procesos, el servicio al cliente y la calidad de su 
            cartera, comprometida con la sociedad, el medio ambiente, colaboradores, socios e inversionistas.
          </p>
        </div>

      </div>
    </div>
    
  </div>
</section>


    </div>
  );
}

export default AboutUs;
